import styled, { css } from 'styled-components';

export const Image = styled.img`
  height: 100%;
  width: 100%;
`;

export const Wrap = styled.div`
  margin-right: 8px;
  height: 50px;
  width: 50px;
  padding: 2px;
  ${({ isActive }) =>
    isActive
      ? css`
          border: 2px dotted ${({ theme }) => theme.palette.global02};
          padding: 0;
        `
      : null};
`;

export default null;



// WEBPACK FOOTER //
// /opt/build/repo/src/app/components/BlendControl/BlendControl.styled.js